// src/components/FloorPlanGenerator/RawResponseDisplay.js

import React, { useState } from 'react';
import './RawResponseDisplay.css';

const RawResponseDisplay = ({ response }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const formattedResponse = typeof response === 'object' 
    ? JSON.stringify(response, null, 2) 
    : response;

  return (
    <div className="raw-response-section">
      <div 
        className="response-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex justify-between items-center p-3 bg-gray-100 rounded-t-lg cursor-pointer">
          <h4 className="text-lg font-medium">Raw AI Response</h4>
          <span>{isExpanded ? '▼' : '▶'}</span>
        </div>
      </div>
      
      {isExpanded && (
        <div className="response-body">
          <pre className="bg-gray-50 p-4 rounded-b-lg overflow-x-auto max-h-60">
            <code>{formattedResponse}</code>
          </pre>
          
          <button
            onClick={() => {
              navigator.clipboard.writeText(formattedResponse);
              alert('Copied to clipboard!');
            }}
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Copy to Clipboard
          </button>
        </div>
      )}
    </div>
  );
};

export default RawResponseDisplay;